import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ConnectionExpiredService {
  private readonly connectionExpiredSub = new BehaviorSubject<boolean>(false);
  public readonly connectionExpired$ = this.connectionExpiredSub.asObservable();

  constructor() {}

  triggerConnectionExpired(): void {
    this.connectionExpiredSub.next(true);
  }

  reset(): void {
    this.connectionExpiredSub.next(false);
  }
}
